import * as React from "react";
import TablePagination from "@mui/material/TablePagination";

// export default function TablePaginationDemo({
//   totalData,
//   rowOnAPage,
//   setLimit,
// }) {
//   const [page, setPage] = React.useState(2);
//   const [rowsPerPage, setRowsPerPage] = React.useState(rowOnAPage);

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setLimit(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   function defaultLabelDisplayedRows({ from, to, count }) {
//     return `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`;
//   }

//   return (
//     <TablePagination
//       component="div"
//       sx={{
//         ".MuiTablePagination-selectLabel, .MuiTablePagination-selectRoot": {
//           display: "none",
//         },
//         display: "flex",
//       }}
//       count={totalData}
//       page={page}
//       onPageChange={handleChangePage}
//       rowsPerPage={rowsPerPage}
//       //   onRowsPerPageChange={handleChangeRowsPerPage}
//     />
//   );
// }

export default function TablePaginationDemo({
  totalData,
  rowOnAPage,
  setLimit,
  pageNo,
  setpageCount,
}) {
  const [page, setPage] = React.useState(10);
  const [rowsPerPage, setRowsPerPage] = React.useState(rowOnAPage);
  const handleData = (e) => {
    setpageCount(1);
    setLimit(e.target.value);
  };

  return (
    <>
      <div style={{ display: "flex", padding: "4px", columnGap: "10px" }}>
        <div>
          <label></label>
          <select onChange={(e) => handleData(e)}>
            <option>10</option>
            <option>30</option>
            <option>50</option>
            <option>100</option>
            <option>200</option>
          </select>
        </div>
        <div className="no_of_pages">
          {`${
            rowOnAPage > totalData ? totalData : rowOnAPage
          } data shown out of ${totalData} from page no.  ${pageNo}`}
        </div>
      </div>
    </>
  );
}
